import React, { useRef, useState } from "react";
import { CSVLink } from "react-csv";
import Button from "../../../component-lib/Molecules/button/Button";
import { DownloadIcon } from "../../../assets";

type CsvHeader = { label: string; key: string };

type DownloadCsvButtonProps = {
  headers: CsvHeader[];
  filename: string;
  // Returns the flat rows to export (e.g. by fetching the report with limit="All")
  fetchRows: () => Promise<Array<Record<string, unknown>>>;
  disabled?: boolean;
};

const DownloadCsvButton = ({
  headers,
  filename,
  fetchRows,
  disabled = false,
}: DownloadCsvButtonProps) => {
  const [rows, setRows] = useState<Array<Record<string, unknown>>>([]);
  const [loading, setLoading] = useState(false);
  const csvRef = useRef<any>(null);

  const handleClick = async () => {
    try {
      setLoading(true);
      const data = await fetchRows();
      setRows(data || []);
      // Wait for the CSVLink to receive the new rows before triggering download
      setTimeout(() => {
        csvRef.current?.link?.click();
      }, 0);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button
        startIcon={
          <img
            style={{ height: "19px" }}
            src={DownloadIcon}
            alt="download"
            className="cursor-pointer w-[19px] h-[19px]"
          />
        }
        label={loading ? "Preparing..." : "Download CSV"}
        variant="outlined"
        onClickCb={handleClick}
        disabled={disabled || loading}
        style={{
          paddingTop: "6px",
          paddingBottom: "6px",
          minWidth: "160px",
          backgroundColor: "white",
          border: "1px solid #1976d2",
          color: "#1976d2",
        }}
      />
      <CSVLink
        ref={csvRef}
        headers={headers}
        data={rows}
        filename={filename}
        className="hidden"
        target="_blank"
      />
    </>
  );
};

export default DownloadCsvButton;
